<template>
  <div class="manage">
    <el-drawer :visible.sync="drawer">
      <el-form :model="form" ref="form" :rules="rules" class="edit-form">
        <div class="header-content" v-if="formType == 'sub'">
          {{ selectedValue }}
        </div>

        <div class="main-content">
          <el-form-item v-for="(item, index) in formLabel" :key="index" :prop="item.prop" :label="item.label + ':'">
            <el-input :placeholder="'请输入' + item.label" v-model="form[item.prop]"></el-input>
          </el-form-item>
        </div>

        <div class="footer-content">
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit">确认</el-button>
            <el-button size="mini" @click="onCancel">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer :with-header="false" :visible.sync="drawerAddList" size="550px" :before-close="onDrawerClose">

      <div class="my-header">
        <div class="header-title-box">批量创建部门</div>
        <div class="btn-area">
          <span style="width: 124px"></span>
          <el-button size="small" type="primary" @click="downloadExcel">模板下载</el-button>
          <span style="width: 100px"></span>
          <el-upload ref="upload" action="#" :on-change="handleFileChange" :auto-upload="false"
                     :file-list="fileList" :multiple="false" :limit="1">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </div>
      </div>

      <el-main class="el-main">

        <el-form :model="form" ref="form" :rules="rules" class="edit-form">
          <div class="main-content">

            <div class="table-area" v-if="userList.length > 0">
              <el-form style="padding-bottom: 10px" size="mini" v-for="(item, index) in userList" :key="index">
                <el-form-item v-for="(v, k) in excelTable" :key="k" :label="v" :required="k.indexOf('*') !== -1">
                  <el-input :disabled="true" v-model="item[k]"></el-input>
                </el-form-item>
                <!--                <el-divider></el-divider>-->
              </el-form>
            </div>
          </div>
        </el-form>
      </el-main>

      <el-footer>
        <div class="footer-content">
          <el-button size="mini" type="primary" v-loading.fullscreen.lock="pageloading" @click="onSubmitAddList">确认</el-button>
          <el-button size="mini" @click="onCancelAddList">取消</el-button>
        </div>
      </el-footer>

    </el-drawer>


    <div>
      <el-row class="content">
        <el-col :span="6" class="left">
          <h4 style="color: grey; margin-left: 10px;">企业组织架构</h4>
          <el-tree class="left-tree"  ref="tree" :data="treeData" highlight-current default-expand-all
                   @node-click="handleNodeClick"></el-tree>
        </el-col>

        <el-col :span="18" class="right">
          <div class="right-header">
            <span>
            <el-button type="primary" size="mini" @click="addTopDepartment()" :disabled="!hasCommitPermission">
              添加部门
            </el-button>
            <el-button type="success" size="mini" @click="addSubDepartment()" :disabled="!hasCommitPermission">
              添加子部门
            </el-button>
              </span>
            <span>
            <el-button size="mini" @click="addDepartmentBatch" :disabled="!hasCommitPermission">
              批量添加
            </el-button>
            </span>
          </div>

          <div class="right-desc">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="name" label="部门名称">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.name }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="comments" label="部门说明">
              </el-table-column>

              <el-table-column prop="state" label="部门状态" width="80px">
                <template slot-scope="scope">
                  <el-tag type="warning">{{ scope.row.state }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="150px">
                <template v-slot="scope">
                  <el-button type="success" size="mini" @click="tableUpdate(scope.row)"
                             :disabled="!hasCommitPermission">修 改
                  </el-button>
                  <el-button type="danger" size="mini" @click="deleteSelected(scope.row)"
                             :disabled="!hasCommitPermission">删 除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {manage_mixin_table} from './manage-mixin'
import {addDepartment, deleteDepartmentByBatch, updateDepartment} from '../../api/organize-api'

export default {
  mixins: [manage_mixin_table],

  mounted() {
    this.loadTreeData()
  },

  data() {
    return {
      rules: {
        name: [
          {required: true, message: '请输入部门名称', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ]
      },

      tableData: [],

      treeData: [],

      drawer: false,

      formType: "",

      selectedValue: "",

      form: {},

      formLabel: [
        {
          prop: 'name',
          label: '部门名称'
        },
        {
          prop: 'comments',
          label: '部门描述'
        }
      ],

      drawerAddList: false,
      userList: [],
      fileList: [],

      excelTable: {
        '部门': '部门',
      },

      pageloading: false,
    };
  },

  methods: {
    addTopDepartment() {
      this.formType = "top"

      this.formLabel = []

      this.formLabel.push({prop: 'name', label: '部门名称'})
      this.formLabel.push({prop: 'comments', label: '部门描述'})

      this.form = {}

      this.drawer = true
    },

    addSubDepartment() {
      let selected = this.$refs.tree.getCurrentNode()

      if (selected == null) {
        this.$message.error('请选择子部门所在的上级部门');

        return
      }

      this.formType = "sub"

      this.formLabel = []

      this.formLabel.push({prop: 'name', label: '子部门名称'})
      this.formLabel.push({prop: 'comments', label: '子部门概述'})

      this.selectedValue = "上级部门：" + this.$refs.tree.getCurrentNode().label

      this.form = {}

      this.drawer = true
    },

    tableUpdate(row) {
      this.formType = "update"

      this.formLabel = []

      this.formLabel.push({prop: 'name', label: '部门名称'})
      this.formLabel.push({prop: 'comments', label: '部门概述'})

      // console.log("row =>", row)
      this.form = {
        "id": row.id,
        "name": row.name,
        "comments": row.comments
      }

      this.drawer = true
    },

    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.formType === "update") {
            this.onSubmitUpdate()
          } else {
            this.onSubmitAdd()
          }
        } else {
          console.log('validate error, error submit!!');
          return false;
        }
      });
    },

    onSubmitUpdate() {
      // console.log("this.form =>", this.form)

      updateDepartment(this.form).then(({data}) => {
        if (data.code == 200) {
          this.tableData = []

          this.tableData.push({
            "id": data.data.id,
            "name": data.data.name,
            "comments": data.data.comments,
            "state": "正常"
          })

          // this.loadTreeData()

          let node = this.$refs.tree.getCurrentNode()
          node.label = data.data.name
          node.comments = data.data.comments

          this.form = {}

          this.drawer = false

          this.$message.success('修改成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(() => {
        this.showNetErrMsg();
      })
    },

    async getTreeDataAsync() {
      await this.loadTreeData()
    },

    onSubmitAdd() {
      if (this.formType === "sub") {
        let selectedNode = this.$refs.tree.getCurrentNode()

        this.form.parentId = selectedNode.id
      } else {
        this.form.parentId = -1
      }

      addDepartment(this.form).then(({data}) => {
        // console.log("data =>", data)

        if (data.code == 200) {
          this.loadTreeData()

          this.drawer = false
          this.$message.success('添加成功');
        } else if (data.code === 700) {
          if (this.form.parentId === -1) {
            this.$message.error("'" + data.data.name + "'" + "部门已经存在");
          } else {
            this.$message.error("'" + data.data.parentName + "'已经存在子部门'" + data.data.name + "'");
          }
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("error => ", error)
        this.showNetErrMsg();
      })
    },

    onCancel() {
      this.drawer = false
    },

    deleteSelected(selectRow) {
      let delDepartmentBatch = []

      delDepartmentBatch.push(selectRow.id)

      deleteDepartmentByBatch(delDepartmentBatch).then(({data}) => {
        // console.log("data => ", data)
        if (data.code === 200) {
          this.loadTreeData()
          this.$message.error('删除成功')
          this.loadTreeData()
          this.tableData = []
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("error => ", error)
        this.showNetErrMsg();
      })
    },

    handleNodeClick(data, node, com) {
      this.tableData = []

      this.tableData.push({
        "id": data.id,
        "name": data.label,
        "comments": data.comments,
        "state": "正常"
      })
    },
    onDrawerClose(done) {
      this.userList = []
      this.drawerAddList = false
      this.fileList = []
      done()
    },

    downloadExcel() {
      const path = "/static/temp/部门创建模板.xlsx"
      let link = document.createElement('a');
      link.style.display = 'none';
      link.download = '部门创建模板.xlsx';
      link.href = path;
      link.click();

      URL.revokeObjectURL(link.href);
    },

    dealExcel(file) {
      console.log("@@@", "dealExcel file", file);
      const XLSX = require('xlsx');

      let rABS = true;
      let reader = new FileReader();
      let ctx = this
      reader.onload = function (e) {
        let data = e.target.result

        if (!rABS) data = new Uint8Array(data);
        let workbook = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
        let firstSheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[firstSheetName]
        const range = XLSX.utils.decode_range(sheet['!ref']);
        range.s.r = 1; // 从第2行开始读取数据

        const result = XLSX.utils.sheet_to_json(sheet, {range})
        console.log("@@@@", "XLSX.result", result);
        ctx.userList = result
      }
      if (rABS) reader.readAsBinaryString(file.raw); else reader.readAsArrayBuffer(file.raw);
    },

    handleFileChange(file, fileList) {
      console.log("@@@", "handleFileChange file", file, fileList);
      let result = file.name.indexOf(".xlsx")
      if (result) {
        this.dealExcel(file)
      } else {
        this.$message.error('请上传正确的表格');
      }
    },

    addDepartmentBatch() {
      this.drawerAddList = true
      this.userList = []
      this.fileList = []
    },

    async onSubmitAddList() {
      console.log("this.userList =>", this.userList)
      this.pageloading = true
      let map = new Map()
      for (const item of this.userList) {
        let departmentList = item['部门'].split('/')
        for (let i = 0; i < departmentList.length; i++) {
          let department = departmentList[i]
          if (map.has(department)) {
            continue
          }
          let parentId = -1
          if (i > 0) {
            parentId = map.get(departmentList[i - 1])
          }
          let postData = {name: department, parentId: parentId, comments: ""}
          let res = await addDepartment(postData)
          map.set(department, res.data.data.id)
        }
      }
      this.pageloading = false
      this.$message.success('批量添加任务完成');
      this.loadTreeData()
      this.drawerAddList = false
    },
    onCancelAddList() {
      this.drawerAddList = false
    }

  },
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("EMPLOYEE_MANAGE_MODIFY")
        default:
          return false
      }
    }
  },

}
</script>

<style lang="less" scoped>

.manage {

  .edit-form {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100%;

    .header-content {
      margin-bottom: 20px;
    }

    .main-content {
      flex: 1 0 auto;

      .el-form-item {
        display: flex;
        justify-content: flex-start;

        /deep/ .el-form-item__label {
          width: 100px;
        }

        /deep/ .el-input {
          width: calc(20vw);
        }
      }
    }

    .footer-content {
      text-align: center;
      flex: 0 0 auto;
    }
  }

  .content {
    display: flex;
    justify-content: space-between;

    .left {
      margin: 0 20px 0 0;

      //border-left: 1px solid #efefef;
      border-right: 1px solid #efefef;
      box-shadow: 2px 2px 2px 2px #efefef;
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      //margin-top: 20px;
      //margin-bottom: 18px;
      //margin-right: 20px;

      .right-header {
        display: flex;
        justify-content: space-between;

        margin-bottom: 20px;
      }

      .right-desc {
        /deep/ .el-table__body-wrapper {
          height: calc(100vh - 240px);
          // height: 700px;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
          /*width: 0;宽度为0隐藏*/
          width: 0px;
        }
      }
    }
  }
}

.el-footer {
  text-align: center;
  line-height: 60px;
}

.my-header {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 150px;

  .header-title-box {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.el-main {
  height: calc(100% - 220px);
  box-sizing: border-box;
  padding: 0;
}

.table-area {
  margin-top: 20px;
}

.btn-area {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;

}

.left-tree {
  height: calc(100vh - 240px);
  overflow-y: auto;
}
</style>
